import React, { useEffect, useState, useMemo, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import "../App.css";
import '../assets/css/BdmAdminTabledetails.css';
import '../assets/css/Jsontable.css';
import { Modal, Button, Form } from 'react-bootstrap';
import { closeButtonStyle, Listoftablesearchbox1, BackButton, RecordsPerPageSelect, SearchBox, submitButtonStyle, cancelButtonStyle, ProceedButtonStyle, UploadLoadingIcon } from "../components/Propertyfile";
import { checkboxrejectpastdata, checkboxapprovepastdata, rejectbulkpastdata, approvebulkpastdata, approvepastdata, rejectpastdata, Checkerlist_deptwisetemplates, Checkerretrievallist, previewrdmdata, approvedatadem, approverdmdata, rejectrdmdata, checkboxreject, checkboxapprove, rejecteddatadem, PortURL, DownloadAPi, createTextFileApi } from "../components/ApiProperty"
import { TableListGapsy, TemplateListGapsy, ListofTableFontsize, PaginationComponentForm2, PaginationComponentForm3, GapsycheckertableStructure, BulkApproveButton, DEMcheckertableStructure } from "../components/TableProperty";
import Header from './gapsy-header';
import Navigation from './gapsy-Cnavigation';
import Footer from './gapsy-footer';
// import "bootstrap-icons/font/bootstrap-icons.css";

// import "bootstrap/dist/css/bootstrap.min.css"
// import 'bootstrap-icons/font/bootstrap-icons.css';
import styles from '../assets/css/gapsy-dashboard.module.css';
import DepartmentDropdown from "../components/Dropdown";
import axios from 'axios';
import { responseBKP } from "../components/Modalpopup";
import { useSession } from '../components/SessionContext';

const GapsyRData = () => {
    // State from first component
    const [tableData, setTableData] = useState([]);
    const [originalJsonData, setOriginalJsonData] = useState([]);
    const [selectedDownloadFormat, setSelectedDownloadFormat] = useState(null); // Store selected format
    const [filteredTables, setFilteredTables] = useState([]);
    const [selectedPrefix, setSelectedPrefix] = useState("");
    const [isViewDemadminData, setisViewDemadminData] = useState(true);
    const [tableNames, setTableNames] = useState([]);
    const [selectedName, setSelectedName] = useState('');
    const [dataModel, setDataModel] = useState("");
    const [currentPage, setCurrentPage] = useState(1);
    const [recordsPerPage, setRecordsPerPage] = useState(5);
    const [prefixes, setPrefixes] = useState([]);
    const [currentPage1, setCurrentPage1] = useState(1);
    const [recordsPerPage1] = useState(7); // Set the number of records per page
    const [initialLoadComplete, setInitialLoadComplete] = useState(false);
    const [modalMessage, setModalMessage] = useState('');
    const [showModal, setShowModal] = useState(false);
    const [modalMessageOne, setModalMessageOne] = useState('');
    const [messageType, setMessageType] = useState('');
    const [searchQuery, setSearchQuery] = useState('');
    const [selectedFullTableName, setSelectedFullTableName] = useState('');
    const [prefix, setPrefix] = useState("");
    const [validErrorRecords, setvalidErrorRecords] = useState("");
    const [isTableVisible, setIsTableVisible] = useState(true);
    const [showBulkActions, setShowBulkActions] = useState(false);
    const [displaySearchValue, setDisplaySearchValue] = useState('');
    const [tableSelected, setTableSelected] = useState(false);
    // State from second component
    const [error, setError] = useState(null);
    const [checkboxRowId, setCheckboxRowId] = useState([]);
    const [fileName, setFileName] = useState('');
    const [selectedRowIds, setSelectedRowIds] = useState([]);
    const [showRejectModal, setShowRejectModal] = useState(false);
    const [showRejectReasonModal, setShowRejectReasonModal] = useState(false);
    const [data, setData] = useState([]);
    const [clickedRowId, setClickedRowId] = useState(null);
    const [bulkModel, setBulkDataModel] = useState(null);
    const [rejectColumns, setRejectColumns] = useState([]);
    const [showReasonModal, setShowReasonModal] = useState(false);
    const [notifyToMaker, setNotifyToMaker] = useState(false);
    const [notifyToChecker, setNotifyToChecker] = useState(false);
    const [endOfDayNotifyToMaker, setEndOfDayNotifyToMaker] = useState(false);
    const [selectedColumn, setSelectedColumn] = useState('');
    const [otherReason, setOtherReason] = useState('');
    const [tableColumns, setTableColumns] = useState([]);
    const [rejectedReason, setRejectedReason] = useState('');
    const [showNotifyPriorityModal, setShowNotifyPriorityModal] = useState(false);
    const [isSubmitEnabled, setIsSubmitEnabled] = useState(false);
    const [search, setSearch] = useState('');
    const [itemsPerPage] = useState(7);
    const [showNoRecordsModal, setShowNoRecordsModal] = useState(false);
    const [showConfirmApproveModal, setShowConfirmApproveModal] = useState(false);
    const [showConfirmApprove, setShowConfirmApprove] = useState(false);
    const [approveRowId, setApproveRowId] = useState(null);
    const [isLoading, setIsLoading] = useState(false);
    const [uploadStatus, setUploadStatus] = useState('');
    const [searchTerm, setSearchTerm] = useState('');
    const [showNotifyModal, setShowNotifyModal] = useState(false);
    const [notificationType, setNotificationType] = useState('IN');
    const [paramState, setParam] = useState('');
    const [allColumns, setAllColumns] = useState([]);
    const [showDropdown, setShowDropdown] = useState(false);
    const dropdownRef = useRef(null);
    const [formError, setFormError] = useState('');
    const navigate = useNavigate();
    const location = useLocation();
    const [tableSourceMap, setTableSourceMap] = useState({});
    const apiSessionId = sessionStorage.getItem("sessionId");
    const department = sessionStorage.getItem("dept");
    const activeStatus = localStorage.getItem("active_status");
    const templateType = localStorage.getItem("template_type");
    const stage = localStorage.getItem("stage");
    const [showOnlyRetrieved, setShowOnlyRetrieved] = useState(false);
    const [allTableList, setAllTableList] = useState([]); // Combined List
    const [retrievedTableList, setRetrievedTableList] = useState([]); // Only retrieved


    // Get the table name from URL params
    const urlParams = new URLSearchParams(location.search);
    const params1 = urlParams.get('param');
    const tablenames = params1 ? params1.substring(params1.indexOf('_') + 1) : '';
    const tableName1 = params1 ? `${params1}_temp` : '';
    const { sessionId } = useSession();
    let csrfToken = sessionStorage.getItem("tokenizedSession");

    const toTitleCase = (str) => {
        return str
            // Replace underscores or hyphens with spaces
            .replace(/[_-]/g, ' ')
            // Add space before capital letters (for camelCase)
            .replace(/([a-z])([A-Z])/g, '$1 $2')
            // Capitalize first letter of each word
            .replace(/\w\S*/g, (w) => w.charAt(0).toUpperCase() + w.slice(1).toLowerCase());
    };

    useEffect(() => {
        fetchData();
        // fetchFormStructureAndData();
    }, []);

    // useEffect(() => {
    //     const storedDept = localStorage.getItem('selectedDept');
    //     const storedTable = localStorage.getItem('selectedTable');
    //     const completedActivity = localStorage.getItem('completedActivity');
    //     const isModifiedPast = (completedActivity || '')
    //         .toLowerCase()
    //         .includes('modified a past data');

    //     if (
    //         storedDept &&
    //         storedTable &&
    //         !initialLoadComplete &&
    //         tableNames &&
    //         typeof tableNames === 'object' &&
    //         Object.keys(tableNames).length >= 0 &&
    //         retrievedTableList !== null
    //     ) {
    //         setSelectedPrefix(storedDept);
    //         setSearchQuery(storedTable);

    //         if (isModifiedPast) {
    //             setShowOnlyRetrieved(true);

    //             const retrievedNames = retrievedTableList?.map(
    //                 obj => Object.keys(obj)[0]?.toLowerCase()
    //             ) || [];

    //             const foundRetrievedTable = retrievedNames.find(
    //                 table => table === storedTable.toLowerCase()
    //             );

    //             if (foundRetrievedTable) {
    //                 handleTableClick(storedTable, '_retrieved');
    //             }
    //         } else {
    //             const foundTable = tableNames[storedDept]?.find(
    //                 table => table.toLowerCase() === storedTable.toLowerCase()
    //             );

    //             if (foundTable) {
    //                 handleTableClick(foundTable);
    //             } else {
    //                 // fallback if table is not in fetched list
    //                 handleTableClick(storedTable);
    //             }
    //         }

    //         setInitialLoadComplete(true);
    //     }
    // }, [tableNames, retrievedTableList, initialLoadComplete]);

    useEffect(() => {
        const storedDept = localStorage.getItem('selectedDept');
        const storedTable = localStorage.getItem('selectedTable');
        const completedActivity = localStorage.getItem('completedActivity');

        const isModifiedPast =
            (completedActivity || '').toLowerCase() === 'modified a past data';

        if (!storedDept || !storedTable || initialLoadComplete) return;

        // ✅ normal tables must exist
        if (!tableNames || typeof tableNames !== 'object') return;

        // ✅ retrieved tables must exist ONLY for past data
        if (isModifiedPast && (!retrievedTableList || retrievedTableList.length === 0)) {
            return;
        }

        setSelectedPrefix(storedDept);
        setSearchQuery(storedTable);

        if (isModifiedPast) {
            setShowOnlyRetrieved(true);

            const retrievedNames = retrievedTableList.map(
                obj => Object.keys(obj)[0]?.toLowerCase()
            );

            const found = retrievedNames.includes(storedTable.toLowerCase());

            if (found) {
                // ✅ force retrieved explicitly
                handleTableClick(storedTable, true);
            }
        } else {
            const foundTable = tableNames[storedDept]?.find(
                table => table.toLowerCase() === storedTable.toLowerCase()
            );

            handleTableClick(foundTable || storedTable);
        }

        setInitialLoadComplete(true);

    }, [tableNames, retrievedTableList]);

    const fetchData = async () => {
        try {
            const config = {
                headers: {
                    userId: localStorage.getItem('userid'), 'x-csrf-token': csrfToken,
                },
                withCredentials: true,
                params: { dept: department }
            };
            const config1 = {
                headers: {
                    userId: localStorage.getItem('userid'), 'x-csrf-token': csrfToken,
                },
                withCredentials: true,
                params: { dept: department, tabletype: 'retrieved', dataModel: 'NA' }
            };

            // Call first API
            const [response1, response2] = await Promise.all([
                axios.post(Checkerlist_deptwisetemplates, {}, config),
                axios.post(Checkerretrievallist, {}, config1)
            ]);

            const message = 'There is no Table for Approve / Reject';
            const combinedTableList = [
                ...(response1.data?.tableList || []),
                // ...(response2.data?.tableList || [])
            ];

            setAllTableList(combinedTableList);
            setRetrievedTableList(response2.data?.tableList || []);
            const tempMap = {};

            (response1.data?.tableList || []).forEach((tableObj) => {
                const fullTableName = Object.keys(tableObj)[0];
                tempMap[fullTableName] = '_temp';
            });

            (response2.data?.tableList || []).forEach((tableObj) => {
                const fullTableName = Object.keys(tableObj)[0];
                tempMap[fullTableName] = '_retrieved';
            });

            setTableSourceMap(tempMap); //  Store the source suffix

            if (combinedTableList.length) {
                const categorizedTables = {};
                const prefixSet = new Set();

                combinedTableList.forEach((tableObj) => {
                    const fullTableName = Object.keys(tableObj)[0];
                    const [prefix] = fullTableName.split('_');
                    prefixSet.add(prefix);

                    if (!categorizedTables[prefix]) {
                        categorizedTables[prefix] = [];
                    }
                    categorizedTables[prefix].push(fullTableName);
                });

                setTableNames(categorizedTables);
                setPrefixes(Array.from(prefixSet));
            } else {
                const updatedMessage = `${message} in department: ${department || 'Unknown'}`;
                responseBKP(response1, setModalMessage, setShowModal, setTableNames, message, updatedMessage);
            }
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };



    useEffect(() => {
        const safeTableNames = tableNames || {};   //  <-- prevents crash

        if (selectedPrefix) {
            setFilteredTables(safeTableNames[selectedPrefix] || []);
        } else {
            setFilteredTables([]);
        }
    }, [selectedPrefix, tableNames]);


    const paginate1 = (pageNumber) => {
        setCurrentPage1(pageNumber);
    };

    useEffect(() => {
        const params = new URLSearchParams(location.search);
        const viewParam = params.get('param');

        if (viewParam === 'view') {
            setisViewDemadminData(true);
        } else if (viewParam === 'modify') {
            setisViewDemadminData(false);
        } else {
            setisViewDemadminData(false);
        }
    }, [location]);

    const handleRetrievedToggle = (isChecked) => {
        setShowOnlyRetrieved(isChecked);

        const retrievedTableNames = retrievedTableList.map(obj => Object.keys(obj)[0]);

        if (!retrievedTableNames.includes(selectedFullTableName)) {
            setSelectedFullTableName(null);
            setTableData([]); // clear when table is deselected via toggle
        } else {
            setTableData([]); // still clear data even if table is retained
        }
    };

    const handleTableClick = async (item, forceRetrieved = false) => {
        setTableSelected(true);

        // ✅ relaxed validation
        if (typeof item !== 'string' || !item.trim()) {
            console.warn("Invalid table name:", item);
            return;
        }

        // Reset states
        setSelectedRowIds([]);
        setShowBulkActions(false);
        setShowConfirmApprove(false);
        setShowRejectModal(false);
        setClickedRowId(null);
        setCheckboxRowId(null);
        setTableData([]);
        setIsLoading(true);

        setSelectedFullTableName(item);
        setParam(item);

        const [prefix, ...restParts] = item.split('_');
        setPrefix(prefix);
        setSelectedName(restParts.join('_'));

        setvalidErrorRecords([]);
        setIsTableVisible(true);

        // ✅ deterministic suffix selection
        const suffix = forceRetrieved || showOnlyRetrieved
            ? '_retrieved'
            : '_temp';

        const newUrl = new URL(window.location.href);
        newUrl.searchParams.set('param', item);
        window.history.replaceState({}, '', newUrl);

        await fetchFormStructureAndData(item, suffix);
    };


    const handleDashboard = () => {
        navigate("/gapsyCdashboard");
        localStorage.removeItem('selectedDept');
        localStorage.removeItem('selectedTable');
        localStorage.removeItem('completedActivity');
        setSelectedPrefix('');
        setSearchQuery('');
    };

    const hanldemodify = () => {
        setShowModal(false);
        navigate(-1);
    };


    // const paginate = (pageNumber) => {
    //     setCurrentPage(pageNumber);
    // };

    // const filteredRecords1 = useMemo(() => {
    //     if (!selectedPrefix) return [];

    //     const query = searchQuery.toLowerCase().trim();
    //     const filteredTablesForPrefix = tableNames[selectedPrefix] || [];

    //     return filteredTablesForPrefix.filter((tableName) =>
    //         tableName.toLowerCase().includes(query)
    //     );
    // }, [tableNames, searchQuery, selectedPrefix]);
    const filteredRecords1 = useMemo(() => {
        if (!selectedPrefix) return [];

        const safeTableNames = tableNames || {}; // <- ensures it's never null/undefined
        const query = searchQuery.toLowerCase().trim();

        const filteredTablesForPrefix = safeTableNames[selectedPrefix] || [];

        return filteredTablesForPrefix.filter((tableName) =>
            tableName.toLowerCase().includes(query)
        );
    }, [tableNames, searchQuery, selectedPrefix]);



    useEffect(() => {
        setCurrentPage1(1);
    }, [searchQuery]);
    useEffect(() => {
        setCurrentPage1(1);
    }, [selectedPrefix]);


    const sortedRecords1 = useMemo(() => {
        return [...filteredRecords1].sort((a, b) => {
            const aStarts = a.toLowerCase().startsWith(searchQuery.toLowerCase());
            const bStarts = b.toLowerCase().startsWith(searchQuery.toLowerCase());
            return bStarts - aStarts;
        });
    }, [filteredRecords1, searchQuery]);

    const indexOfLastRecord = currentPage1 * recordsPerPage1;
    const indexOfFirstRecord = indexOfLastRecord - recordsPerPage1;
    const currentRecords1 = sortedRecords1.slice(indexOfFirstRecord, indexOfLastRecord);

    const totalPages1 = Math.ceil(sortedRecords1.length / recordsPerPage1);



    const handlemodalclose = () => {
        setModalMessageOne("");
    };

    useEffect(() => {
        // Format for display: remove prefix and replace underscores with spaces
        const formattedDisplay = searchQuery.includes('_')
            ? searchQuery.substring(searchQuery.indexOf('_') + 1).replace(/_/g, ' ')
            : searchQuery;

        setDisplaySearchValue(formattedDisplay);
    }, [searchQuery]);

    const handleSearchChange = (e) => {
        const input = e.target.value.trimStart(); // Remove leading spaces
        setSearchQuery(input);

        const pageNumber = parseInt(input, 10);

        // Check if input is a valid page number
        if (!isNaN(pageNumber) && pageNumber >= 1 && pageNumber <= totalPages1) {
            paginate1(pageNumber);
        }
    };

    // const handleSearchChange = (e) => {
    //     setSearchQuery(e.target.value.trimStart());
    // };

    // const isRetrievedTable = tableData?.[0]?.flag === 'M'; 
    const isRetrievedTable = ['M', 'R'].includes(tableData?.[0]?.flag);


    const fetchFormStructureAndData = async (paramValue, suffix = '_temp') => {
        try {
            setIsLoading(true);
            setParam(paramValue);
            setSelectedRowIds([]);
            setError(null); // Clear any previous errors

            // 1. First fetch the form structure
            // const formResponse = await fetch(`${PortURL}/demformtemplate/${paramValue}.json`);
            const formResponse = await fetch(`/demformtemplate/${paramValue}.json`);
            if (!formResponse.ok) {
                throw new Error('Select the Table');
            }
            const formStructure = await formResponse.json();


            // 2. Get active columns from form structure
            const activeColumns = formStructure.details
                .filter(detail => detail.columnActive !== "N")
                .map(detail => detail.columnName);

            // 3. Always include these columns in the display
            // 3. Always include these columns in the display unless it's _retrieved
            const excludedSystemColumns = ['created_by', 'created_dt', 'modified_by', 'modified_dt'];

            const conditionalHiddenColumns = suffix === '_retrieved'
                ? ['Maker_Remarks', 'Rejected_Reason', 'approved_dt', 'approved_by']
                : [];

            const columnsToDisplay = [
                ...new Set([
                    ...activeColumns,
                    ...(suffix !== '_retrieved' ? ['Maker_Remarks'] : [])
                ])
            ].filter(col => !excludedSystemColumns.includes(col) && !conditionalHiddenColumns.includes(col));


            // 4. Fetch the data from API
            const config = {
                headers: {
                    "userId": localStorage.getItem('userid'), 'x-csrf-token': csrfToken,
                },
                withCredentials: true,
                params: {
                    // "tableName": `${paramValue}_temp`,
                    "tableName": `${paramValue}${suffix}`,
                    "dataModel": "DEM"
                }
            };

            const apiResponse = await axios.post(previewrdmdata, {}, config);
            if (!apiResponse.data?.fileName) {
                throw new Error('No data file available for preview');
            }

            const fetchedFileName = apiResponse.data.fileName;
            setFileName(fetchedFileName);

            // 5. Fetch and parse the JSON data file
            // const dataResponse = await fetch(`${PortURL}/jsonfiles/${fetchedFileName}`);
            const dataResponse = await fetch(`/jsonfiles/${fetchedFileName}`);
            if (!dataResponse.ok) throw new Error('Failed to load data file');

            const jsonData = await dataResponse.json();

            const filteredData = jsonData.filter(row => {
                const rejectedReason = (row.Rejected_Reason || "").trim();
                const nullLikeValues = ["\\N", "\N", "NULL", ""];

                if (suffix === '_retrieved') {
                    return (
                        (row.flag === 'M' &&
                            rejectedReason === 'Ready for validation. (updated)') ||

                        (row.flag === 'R' &&
                            nullLikeValues.includes(rejectedReason))
                    );
                } else {
                    return !rejectedReason || nullLikeValues.includes(rejectedReason);
                }
            });


            // 7. Extract unique data models
            const uniqueDataModels = [...new Set(
                filteredData.map(row => row.dataModel).filter(Boolean)
            )];
            setBulkDataModel(uniqueDataModels.join(','));

            // 8. Prepare the data for display
            const tableDataToDisplay = filteredData.map(row => {
                const displayRow = {};

                columnsToDisplay.forEach(col => {
                    if (col === 'Maker_Remarks') {
                        const remarks = row[col]?.trim();
                        displayRow[col] = ["\\N", "//N", "/N", "NULL", ""].includes(remarks) ? "" : remarks;
                    } else {
                        displayRow[col] = row[col] ?? "";
                    }
                });

                return displayRow;
            });



            // 9. Update state with the processed data
            setAllColumns(activeColumns);
            setTableColumns(columnsToDisplay);
            // setTableData(jsonData);
            // setTableData(filteredData); // Only non-rejected, selectable rows
            setOriginalJsonData(jsonData);       // for reference/export
            setTableData(filteredData);          // for table + selection logic
            setFormError('');

        } catch (error) {
            console.error('Error fetching data:', error);
            setError(error.message === "Select the Table" ? [] : error);
            setTableData([]); // Clear table data on error
            setFormError(error.message);
        } finally {
            setIsLoading(false);
            setSelectedRowIds([]);
        }
    };

    const reasonColumnConfig = {
        HR_overall_saudization_rate: [
            "reporting_date",
            "total_employees_saudi_national",
            "total_employees",
            "value"
        ],
        Finance_return_on_equity: [
            "reporting_date",
            "annualized_net_profit",
            "average_shareholders_equity",
            "value"
        ]
    };

    const formatColumnLabel = (column) => {
        return column
            .replace(/_/g, " ")
            .toLowerCase()
            .replace(/\b\w/g, (char) => char.toUpperCase());
    };

    useEffect(() => {
        return () => {
            localStorage.removeItem('demCheckerSelectedColumns');
        };
    }, []);


    const downloadTable = async () => {
        try {
            const selectedColumns = JSON.parse(localStorage.getItem('demCheckerSelectedColumns')) || [];

            const config = {
                headers: {
                    "userId": localStorage.getItem('userid'), 'x-csrf-token': csrfToken,
                },
                withCredentials: true,
                params: { "tableName": tableName1, "dataModel": "DEM", "activity": "download" }
            };

            const apiresponse = await axios.post(DownloadAPi, {}, config);
            const response = await fetch(`./downloads/${tableName1}.csv`);
            const csvText = await response.text();

            const rows = csvText.trim().split('\n').map(row => row.split(','));
            const header = rows[0];

            const dropdownOptionsMap = {
                created_by: '"created_by"',
                created_dt: '"created_dt"',
                modified_by: '"modified_by"',
                modified_dt: '"modified_dt"',
            };

            const allowedHeaders = Object.entries(dropdownOptionsMap)
                .filter(([key]) => selectedColumns.includes(key))
                .map(([_, headerName]) => headerName);

            const columnsToRemove = header.filter(h =>
                ['"created_by"', '"created_dt"', '"modified_by"', '"modified_dt"'].includes(h) &&
                !allowedHeaders.includes(h)
            );

            const indicesToRemove = header.map((col, idx) =>
                columnsToRemove.includes(col) || ['"dataModel"', '"rowId"'].includes(col) ? idx : -1
            ).filter(idx => idx !== -1);

            const cleanedRows = rows.map(row => row.filter((_, idx) => !indicesToRemove.includes(idx)));
            const cleanedCsv = cleanedRows.map(row => row.join(',')).join('\n');

            const blob = new Blob([cleanedCsv], { type: 'text/csv' });
            const link = document.createElement('a');
            link.href = URL.createObjectURL(blob);
            link.download = `${tablenames}.csv`;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);

        } catch (error) {
            console.error('Error downloading table:', error);
        }
    };



    const handleApprove = (clickedRowId) => {
        setApproveRowId(clickedRowId);
        // selectedRowIds([]);
        // setDataModel(dataModel);
        const selectedRow = tableData.find(row => String(row.rowId) === String(clickedRowId));
        setDataModel(selectedRow.dataModel || "Unknown");
        setShowConfirmApproveModal(true);
    };

    const handleConfirmApprove = async () => {
        try {
            if (!fileName) {
                throw new Error('File name parameter (fileName) is missing or invalid.');
            }

            const tableNameWithoutTemp = fileName.replace('_temp.json', '');

            // 🔍 Find the row from tableData using approveRowId
            const currentRow = tableData.find(row => row.rowId == approveRowId);
            if (!currentRow) {
                throw new Error('Row data not found for approval');
            }

            // const isRetrieved = currentRow.flag === 'M' || currentRow.flag === 'R';
            const isRetrieved = fileName.includes('_retrieved');

            const config = {
                headers: {
                    "userId": localStorage.getItem('userid'),
                    'x-csrf-token': csrfToken,
                },
                withCredentials: true,
                params: isRetrieved ? {
                    // For Retrieved Data
                    "rowId": approveRowId,
                    "approveStatus": "Y",
                    "tableName": selectedName,
                    "dataModel": dataModel,
                    "rejectedReason": "",
                    "Notifications": "IN",
                    "dept": prefix
                } : {
                    // For Non-Retrieved Data
                    "rowId": approveRowId,
                    "tableName": selectedName,
                    "status": 1,
                    "dataModel": dataModel,
                    "rejectedReason": null,
                    "dept": prefix,
                    "filePath": `/saswork/nas/${selectedName}`
                }
            };

            const apiUrl = isRetrieved ? approvepastdata : approvedatadem;

            const apiresponse = await axios.post(apiUrl, {}, config);

            if (apiresponse.data?.active_status && apiresponse.data?.template_type) {
                localStorage.setItem("active_status", apiresponse.data.active_status);
                localStorage.setItem("template_type", apiresponse.data.template_type);
                localStorage.setItem("stage", apiresponse.data.stage);
            }

            if (
                apiresponse.data?.message === 'Data Approved' ||
                apiresponse.data?.message === 'Updated Past Data Approved'
            ) {
                setModalMessage(`1 record of <strong>${toTitleCase(selectedName)}</strong> Approved Successfully`);
                setMessageType('success');

                if (tableData.length <= 1) {
                    const suffix = showOnlyRetrieved ? '_retrieved' : '_temp';
                    await fetchFormStructureAndData(selectedFullTableName, suffix);
                } else {
                    setTableData(prev => prev.filter(row => row.rowId !== approveRowId));
                }
            } else {
                setModalMessage(apiresponse.data?.message || 'Approval failed');
                setMessageType('error');
            }


            setShowConfirmApproveModal(false);
            setShowModal(true);
            setSelectedRowIds([]);

        } catch (error) {
            if (error.apiresponse?.status === 409) {
                setUploadStatus('File already exists.');
                setModalMessage(error.apiresponse.data.message);
            } else {
                console.error('Error approving data:', error.apiresponse?.data || error.message);
                setUploadStatus('Error approving file.');
            }
            setMessageType('error');
            setShowConfirmApproveModal(false);
        } finally {
            setSelectedRowIds([]);
        }
    };


    const handleApproveBulk = () => {
        // setApproveRowId(clickedRowId);
        setShowConfirmApprove(true);
    };

    const handleBulkApprove = async () => {
        const selectedRowsCopy = [...selectedRowIds];

        try {
            const selectedCount = selectedRowsCopy.length;

            if (!fileName) throw new Error('File name parameter (fileName) is missing or invalid.');

            const tableNameWithoutTemp = fileName.replace('_temp.json', '');

            const isAllFilteredSelected =
                selectedRowIds.length > 0 && selectedRowIds.length === tableData.length;

            const selectedRowsData = tableData.filter(row => selectedRowIds.includes(row.rowId));
            // const isAllRetrieved = selectedRowsData.every(row => row.flag === 'M');
            const isAllRetrieved = selectedRowsData.every(row => row.flag === 'M' || row.flag === 'R');


            let rowIdParam = '';
            let apiUrl = '';
            let apiresponse;

            if (isAllFilteredSelected) {
                rowIdParam = 0;
                apiUrl = isAllRetrieved ? approvebulkpastdata : approverdmdata;
            } else if (selectedRowsCopy.length > 1) {
                apiUrl = isAllRetrieved ? checkboxapprovepastdata : checkboxapprove;
            } else if (selectedRowsCopy.length === 1) {
                rowIdParam = selectedRowsCopy[0];
                // apiUrl = selectedRowsData[0].flag === 'M' ? rejectpastdata : rejecteddatadem;
                apiUrl = ['M', 'R'].includes(selectedRowsData[0].flag) ? approvepastdata : approvedatadem;

            } else {
                rowIdParam = 0;
                apiUrl = approverdmdata;
            }

            const config = {
                headers: {
                    "userId": localStorage.getItem('userid'), 'x-csrf-token': csrfToken,
                },
                withCredentials: true,
                params: {
                    rowId: rowIdParam,
                    tableName: selectedName,
                    status: 1,
                    dataModel: "BDM",
                    rejectedReason: "",
                    dept: prefix
                }
            };

            if (apiUrl === checkboxapprove || apiUrl === checkboxapprovepastdata) {
                // Send selected row IDs in body for checkbox APIs (both regular and retrieval)
                apiresponse = await axios.post(apiUrl, selectedRowsCopy, config);
            } else {
                // Other APIs: send empty body
                apiresponse = await axios.post(apiUrl, {}, config);
            }

            if (apiresponse.data?.active_status && apiresponse.data?.template_type) {
                localStorage.setItem("active_status", apiresponse.data.active_status);
                localStorage.setItem("template_type", apiresponse.data.template_type);
                localStorage.setItem("stage", apiresponse.data.stage);
            }

            if (["Data Approved", "Data Approved Successfully"].includes(apiresponse.data?.message)) {
                setModalMessage(
                    `${selectedRowsCopy.length} record${selectedRowsCopy.length !== 1 ? 's' : ''} ` +
                    `of <strong>${toTitleCase(selectedName)}</strong> Approved Successfully`
                );
                setMessageType('success');
            } else {
                setModalMessage(apiresponse.data?.message || 'Approval failed');
                setMessageType('error');
            }

            setShowModal(true);
            setShowConfirmApprove(false);
        } catch (error) {
            console.error('Error Approving data:', error);
            setModalMessage('An error occurred while submitting the data.');
            setMessageType('error');
            setShowModal(true);
        } finally {
            setShowConfirmApprove(false);
            setShowModal(true);
            setSelectedRowIds([]);
        }
    };


    const handleRecordsPerPageChange = (e) => {
        setRecordsPerPage(Number(e.target.value)); // Update recordsPerPage state
        setCurrentPage(1); // Reset to the first page
    };

    const handleReject = (clickedRowId) => {
        try {
            setShowRejectReasonModal(true);
            setClickedRowId(clickedRowId);
            const selectedRow = tableData.find(row => String(row.rowId) === String(clickedRowId));
            setDataModel(selectedRow.dataModel || "Unknown");
            const columns = Object.keys(data[0]).filter(key => key !== 'rowId' && key !== 'rejectedReason' && key !== 'flag' && key !== 'modified_dt' && key !== 'modified_by' && key !== 'created_by' && key !== 'created_dt' && key !== 'Rejected_Reason' && key !== 'rowId' && key !== 'dataModel' && key !== 'modified_by' && key !== 'modified_dt' && key !== 'Maker_Remarks');
            setRejectColumns(columns);
            setSelectedColumn('');
            setOtherReason('');
        } catch (error) {
            console.error('Error rejecting data:', error);
        }
    };


    const handleRejectSubmit = () => {
        if (!selectedColumn || (selectedColumn === 'Others' && !otherReason.trim())) {
            setModalMessage('Please provide a valid rejection reason.');
            setShowModal(true);
            return;
        }

        // Combine selectedColumn and otherReason into a single string
        // const reason = `${selectedColumn}: ${otherReason.trim()}`;
        const reason = (selectedColumn === "DeleteRecord" || selectedColumn === "Others")
            ? otherReason.trim()
                ? `${otherReason.trim()}`
                : `${selectedColumn}`
            : otherReason.trim()
                ? `${selectedColumn} is not correct: ${otherReason.trim()}`
                : `${selectedColumn} is not correct`;
        // Set the rejected reason to the combined value
        setRejectedReason(reason);

        // Optionally handle other logic
        setShowRejectModal(false);
        // setShowNotifyModal(true);


        handleBulkSubmit(reason);
    };

    const handleBulkReject = (clickedRowId, checkboxRowId) => {
        try {
            setShowRejectModal(true);
            setClickedRowId(clickedRowId);
            setCheckboxRowId(checkboxRowId);
            const columns = Object.keys(tableData[0]).filter(key =>
                !['rowId', 'Rejected_Reason', 'rejectedReason', 'created_dt',
                    'created_by', 'dataModel', 'modified_by', 'modified_dt',
                    'Maker_Remarks'].includes(key)
            );
            setRejectColumns(columns);
            setSelectedColumn('');
            setOtherReason('');
            setShowRejectModal(true);
        } catch (error) {
            console.error('Error rejecting data:', error);
        }
    };


    const handleBulkSubmit = async (reason) => {
        const selectedRowsCopy = [...selectedRowIds];

        try {
            const selectedCount = selectedRowsCopy.length;

            if (!fileName) throw new Error('File name parameter (fileName) is missing or invalid.');

            const tableNameWithoutTemp = fileName.replace('_temp.json', '');

            const isAllFilteredSelected =
                selectedRowIds.length > 0 && selectedRowIds.length === tableData.length;

            const selectedRowsData = tableData.filter(row => selectedRowIds.includes(row.rowId));
            // const isAllRetrieved = selectedRowsData.every(row => row.flag === 'M');
            const isAllRetrieved = selectedRowsData.every(row => row.flag === 'M' || row.flag === 'R');


            let rowIdParam = '';
            let apiUrl = '';

            if (isAllFilteredSelected) {
                rowIdParam = 0;
                apiUrl = isAllRetrieved ? rejectbulkpastdata : rejectrdmdata;
            } else if (selectedRowsCopy.length > 1) {
                apiUrl = isAllRetrieved ? checkboxrejectpastdata : checkboxreject;
            } else if (selectedRowsCopy.length === 1) {
                rowIdParam = selectedRowsCopy[0];
                // apiUrl = selectedRowsData[0].flag === 'M' ? rejectpastdata : rejecteddatadem;
                apiUrl = ['M', 'R'].includes(selectedRowsData[0].flag) ? rejectpastdata : rejecteddatadem;

            } else {
                rowIdParam = 0;
                apiUrl = rejectrdmdata;
            }

            const config = {
                headers: {
                    "userId": localStorage.getItem('userid'), 'x-csrf-token': csrfToken,
                },
                withCredentials: true,
                params: {
                    "rowId": rowIdParam,
                    "tableName": selectedName,
                    "status": 0,
                    "dataModel": bulkModel,
                    "rejectedReason": reason,
                    "Notifications": "IN",
                    "isBulk": 1,
                    "dept": prefix
                }
            };

            let apiresponse;

            if (apiUrl === checkboxreject || apiUrl === checkboxrejectpastdata) {
                // Send body only for checkbox APIs
                apiresponse = await axios.post(apiUrl, selectedRowsCopy, config);
            } else {
                apiresponse = await axios.post(apiUrl, {}, config);
            }

            if (apiresponse.data?.active_status && apiresponse.data?.template_type) {
                localStorage.setItem("active_status", apiresponse.data.active_status);
                localStorage.setItem("template_type", apiresponse.data.template_type);
                localStorage.setItem("stage", apiresponse.data.stage);
            }

            const responseMsg = apiresponse.data?.message;

            if (
                responseMsg === 'Data Rejected Successfully' ||
                responseMsg === 'Data Rejected' ||
                responseMsg === 'Retrieved Data rejected, allowed for the modification' ||
                responseMsg === 'Past Data Rejected'
            ) {
                setModalMessage(
                    `${selectedCount} record${selectedCount !== 1 ? 's' : ''} ` +
                    `of <strong>${toTitleCase(selectedName)}</strong> Rejected Successfully`
                );
                setMessageType('success');
            } else {
                setModalMessage(responseMsg || 'Rejection failed');
                setMessageType('error');
            }

            setShowNotifyModal(false);
            setShowModal(true);
            setSelectedRowIds([]);
            setShowRejectModal(false);

        } catch (error) {
            console.error('Error rejecting data:', error);
            setModalMessage('An error occurred while rejecting the data.');
            setMessageType('error');
            setShowModal(true);
        } finally {
            setShowNotifyModal(false);
            setShowModal(true);
            setSelectedRowIds([]);
        }
    };






    const handleNotificationTypeChange = (type) => {
        setNotificationType(type);
    };




    const isValidRow = (item, isRetrievedTable) => {
        const rejectedReason = (item.Rejected_Reason || "").trim();
        const nullLikeValues = ["\\N", "\N", "NULL", ""];

        if (isRetrievedTable) {
            if (
                item.flag === "M" &&
                rejectedReason === "Ready for validation. (updated)"
            ) {
                return true;
            }

            if (item.flag === "R" && nullLikeValues.includes(rejectedReason)) {
                return true;
            }

            return false;
        } else {
            return nullLikeValues.includes(rejectedReason);
        }
    };

    const handleReasonSubmit = () => {
        if (!selectedColumn || (selectedColumn === 'Others' && !otherReason.trim())) {
            setModalMessage('Please provide a valid rejection reason.');
            setShowModal(true);
            return;
        }

        // Combine selectedColumn and otherReason into a single string
        // const reason = `${selectedColumn}: ${otherReason.trim()}`;
        const reason = (selectedColumn === "DeleteRecord" || selectedColumn === "Others")
            ? otherReason.trim()
                ? `${otherReason.trim()}`
                : `${selectedColumn}`
            : otherReason.trim()
                ? `${selectedColumn} is not correct: ${otherReason.trim()}`
                : `${selectedColumn} is not correct`;

        // Set the rejected reason to the combined value
        setRejectedReason(reason);


        // Optionally handle other logic
        setShowRejectReasonModal(false);
        // setShowNotifyPriorityModal(true);...
        handleSubmit(reason);
    };


    const handleOtherReasonChange = (e) => {
        setOtherReason(e.target.value);
    };
    // useEffect(() => { fetchFormStructureAndData(); }, []);


    const goBack = () => {
        const filteredtheDataforCount = tableData.filter(item =>
            isValidRow(item, isRetrievedTable)
        );

        setModalMessage(false);
        setSelectedRowIds([]);
        setSelectedColumn('');
        setSearchTerm('');

        if (filteredtheDataforCount.length <= 1) {
            // navigate("/DEMcheckertablelist");
        } else {
            const suffix = showOnlyRetrieved ? '_retrieved' : '_temp';
            fetchFormStructureAndData(selectedFullTableName, suffix);
        }
    };


    const handleColumnSelect = (event) => {
        setSelectedColumn(event.target.value);
        // Clear the otherReason if a column is selected
        if (event.target.value !== 'Others') {
            setOtherReason('');
        }
    };

    const checkSubmitButtonState = (selectedColumn, isNotifyChecked) => {
        if (selectedColumn && isNotifyChecked) {
            setIsSubmitEnabled(true);
        } else {
            setIsSubmitEnabled(false);
        }
    };

    const handleNotifyMakerChange = (checked) => {
        setNotifyToMaker(checked);
        checkSubmitButtonState(selectedColumn, checked || endOfDayNotifyToMaker);
    };

    const handleEndOfDayNotifyChange = (checked) => {
        setEndOfDayNotifyToMaker(checked);
        checkSubmitButtonState(selectedColumn, notifyToMaker || checked);
    };



    const handleReasonClose = () => {
        setShowRejectReasonModal(false);
        setSelectedColumn('');
        setOtherReason('');
        setNotifyToChecker(false);
        setEndOfDayNotifyToMaker(false);
    };




    const handleSubmit = async (reason) => {
        try {
            if (!fileName) {
                throw new Error('File name parameter (fileName) is missing or invalid.');
            }

            const tableNameWithoutTemp = fileName.replace('_temp.json', '');

            // 🔍 Find the row from tableData using clickedRowId
            const currentRow = tableData.find(row => row.rowId == clickedRowId);

            if (!currentRow) {
                throw new Error('Clicked row data not found');
            }

            const isRetrieved = currentRow.flag === 'M' || currentRow.flag === 'R';

            const config = {
                headers: {
                    "userId": localStorage.getItem('userid'), 'x-csrf-token': csrfToken,
                },
                withCredentials: true,
                params: isRetrieved ? {
                    // For Retrieved Data
                    "rowId": clickedRowId,
                    "approveStatus": "N",
                    "tableName": selectedName,
                    "rejectedReason": reason,
                    "dataModel": dataModel,
                    "Notifications": "IN",
                    "dept": prefix
                } : {
                    // For Non-Retrieved Data
                    "rowId": clickedRowId,
                    "tableName": selectedName,
                    "status": 0,
                    "dataModel": dataModel,
                    "rejectedReason": reason,
                    "Notifications": "IN",
                    "dept": prefix
                }
            };

            const apiUrl = isRetrieved ? rejectpastdata : rejecteddatadem;

            const apiresponse = await axios.post(apiUrl, {}, config);

            if (apiresponse.data?.message === 'Data Rejected' || apiresponse.data?.message === "Past Data rejected, allowed for the modification") {
                setModalMessage(`1 record of <strong>${toTitleCase(selectedName)}</strong> Rejected Successfully`);
                setMessageType('success');
                setSelectedRowIds([]);
                setShowNotifyPriorityModal(false);
                setShowModal(true);

                if (tableData.length <= 1) {
                    // await fetchFormStructureAndData(selectedFullTableName);
                    const suffix = showOnlyRetrieved ? '_retrieved' : '_temp';
                    await fetchFormStructureAndData(selectedFullTableName, suffix);

                } else {
                    setTableData(prev => prev.filter(row => row.rowId !== clickedRowId));
                }
            } else {
                setModalMessage(apiresponse.data?.message || 'Rejection failed');
                setShowNotifyPriorityModal(false);
                setShowModal(true);
                setSelectedRowIds([]);
            }

            setShowRejectReasonModal(false);

        } catch (error) {
            console.error('Error Rejecting data:', error);
        }
    };




    const filteredByRejectedReason = tableData.filter(item =>
        isRetrievedTable
            ? (
                (item.flag === "M" &&
                    item.Rejected_Reason?.trim() === "Ready for validation. (updated)") ||

                (item.flag === "R" &&
                    ["\\N", "\N", "NULL", ""].includes((item.Rejected_Reason || "").trim()))
            )
            : ["\\N", "\N", "NULL", ""].includes((item.Rejected_Reason || "").trim())
    );


    // Further filter based on searchTerm
    const filteredTableData = filteredByRejectedReason.filter(item =>
        Object.values(item).some(value =>
            String(value).toLowerCase().includes(searchTerm.toLowerCase())
        )
    );


    const totalRecords = filteredTableData.length;
    const totalPages = Math.ceil(totalRecords / recordsPerPage);

    // Current records based on pagination
    const currentRecords = filteredTableData.slice((currentPage - 1) * recordsPerPage, currentPage * recordsPerPage);

    // Handle page change
    const paginate = (pageNumber) => {
        if (pageNumber >= 1 && pageNumber <= totalPages) {
            setCurrentPage(pageNumber);
        }
    };

    // Handle search input
    const handleSearch = (event) => {
        // const searchInput = event.target.value.trim().toLowerCase();
        const searchInput = event.target.value.toLowerCase(); // Removed trim()
        setSearchTerm(searchInput);
        setCurrentPage(1); // Reset pagination to the first page on search
        setSelectedRowIds([]); // Clear selections when searching

    };

    // Use effect to show modal or alert if no records found
    useEffect(() => {
        if (searchTerm && filteredTableData.length === 0) {
            setShowNoRecordsModal(true);
            setSearchTerm(''); // Clear the search input
            setCurrentPage(1); // Reset to the first page
            // Optionally clear search or handle no records found modal here
        }
    }, [searchTerm, filteredTableData]);


    const handleDropdownChange = (event) => {
        setSelectedColumn(event.target.value);
        setShowDropdown(false); // Close dropdown when an option is selected
    };




    const handleClickOutside = (event) => {
        if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
            setShowDropdown(false);
        }
    };

    const handleCheckboxChange = (rowId) => {
        setSelectedRowIds((prev) => {
            let updated;
            if (prev.includes(rowId)) {
                updated = prev.filter(id => id !== rowId);
            } else {
                updated = [...prev, rowId];
            }
            setCheckboxRowId(updated); // Make sure this sets the updated rowIds
            return updated;
        });
    };


    const handleSelectAll = () => {
        // Use filteredTableData when search is active, otherwise tableData
        const dataSource = searchTerm ? filteredTableData : tableData;


        const allSelectableRowIds = dataSource
            .filter(item => isValidRow(item, isRetrievedTable))
            .map(item => item.rowId);


        const isAllSelected = allSelectableRowIds.length > 0 &&
            allSelectableRowIds.every(rowId => selectedRowIds.includes(rowId));
        const updatedSelection = isAllSelected ? [] : allSelectableRowIds;

        setSelectedRowIds(updatedSelection);
        setCheckboxRowId(updatedSelection);
    };

    // Get counts for display

    const totalSelectableRecords = tableData.filter(item =>
        isValidRow(item, isRetrievedTable)
    ).length;



    const filteredSelectableRecords = searchTerm
        ? filteredTableData.filter(item => isValidRow(item, isRetrievedTable)).length
        : totalSelectableRecords;




    const allSelectableRowIds = filteredTableData
        .filter(item => isValidRow(item, isRetrievedTable))
        .map(item => item.rowId);


    const handleSelectedRowIdsChange = (updatedSelectedRowIds) => {
        setSelectedRowIds(updatedSelectedRowIds);
    };

    useEffect(() => {
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);



    const hasRejectedRecords = tableData.some(item =>
        isValidRow(item, isRetrievedTable)
    );


    const showSearchInput = tableData.length > 0 && hasRejectedRecords;



    const isReasonRequired = selectedColumn === 'Others';
    const isSubmitDisabled = !selectedColumn || (isReasonRequired && !otherReason.trim());

    //table format code
    const dropdownOptions = [
        { key: 'created_by', label: 'Created By' },
        { key: 'created_dt', label: 'Created Date' },
        { key: 'modified_by', label: 'Modified By' },
        { key: 'modified_dt', label: 'Modified Date' },
    ];

    const handleDownloadClick = () => {
        if (!tableData || tableData.length === 0) {
            return;
        }

        const excludedColumns = [
            "rowId",
            "Maker_Remarks",
            "dataModel",
            "Rejected_Reason",
            "created_by",
            "created_dt",
            "modified_dt",
            "modified_by",
            "active_yn"
        ];

        // Remove excluded columns
        const cleanedData = tableData.map(row => {
            const newRow = {};
            Object.keys(row).forEach(key => {
                if (!excludedColumns.includes(key)) {
                    newRow[key] = row[key];
                }
            });
            return newRow;
        });

        // Generate CSV
        const headers = Object.keys(cleanedData[0]);
        const csvRows = cleanedData.map(row =>
            headers.map(header => {
                let val = row[header];

                if (val === null || val === undefined) return "";

                if (typeof val === "string" && val.trim() === "\\N") {
                    return "";
                }

                return val.toString();
            }).join(",")
        );
        const csvContent = [headers.join(","), ...csvRows].join("\n");

        const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
        triggerDownload(blob, `${selectedName || "table"}.csv`);
    };

    // Helper to trigger download
    const triggerDownload = (blob, filename) => {
        const url = URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.download = filename;
        document.body.appendChild(link);
        link.click();
        link.remove();
        URL.revokeObjectURL(url);
    };


    return (
        <div className={`d-flex flex-column min-vh-100 ${styles.pageFullBackground}`}>
            <Header />
            <Navigation />
            <div className="top-0 px-4 py-2 text-white">
                <div className="d-flex justify-content-between align-items-center flex-wrap">
                    <div>
                        <nav aria-label="breadcrumb">
                            <ol className="breadcrumb mb-1">
                                <li className={`breadcrumb-item ${styles.breadcrumbItem}`}>
                                    <a onClick={handleDashboard} className={`text-dark ${styles.breadcrumbLink}`}>
                                        <i className="bi bi-house me-2" style={{ cursor: "pointer" }}></i>/
                                    </a>

                                </li>
                                <li className={`breadcrumb-item active ${styles.breadcrumbItem}`} aria-current="page">
                                    <i className="bi bi-arrow-left-right me-2"></i>3.1 Approve/Reject
                                </li>
                            </ol>
                        </nav>
                    </div>
                </div>
            </div>
            <main className="flex-grow-1 container-fluid">
                <div className={styles.mainContainer}>
                    <div className="container-fluid">
                        <div className="row">
                            {/* left side Column code */}
                            <div className="col-lg-4 col-md-12">
                                <div className={`card h-100 ${styles.cardBorder} ${styles.card}`}>
                                    <div className="card-body">
                                        <div className="d-flex align-items-center gap-2 mb-2">
                                            <div>
                                                <DepartmentDropdown
                                                    selectedPrefix={selectedPrefix}
                                                    setSelectedPrefix={setSelectedPrefix}
                                                    prefixes={prefixes}
                                                />
                                            </div>
                                            <div className="flex-grow-1">
                                                <Listoftablesearchbox1
                                                    // searchQuery={searchQuery}
                                                    searchQuery={displaySearchValue}
                                                    onSearchChange={handleSearchChange}
                                                />
                                            </div>
                                        </div>



                                        <TableListGapsy
                                            currentRecords={
                                                selectedPrefix
                                                    ? (showOnlyRetrieved ? retrievedTableList : allTableList)
                                                    : []
                                            }
                                            ListofTableFontsize={ListofTableFontsize}
                                            handleTableClick={handleTableClick}
                                            currentPage={currentPage1}
                                            recordsPerPage={recordsPerPage1}
                                            selectedTable={selectedFullTableName}
                                            showOnlyRetrieved={showOnlyRetrieved}
                                            handleRetrievedToggle={handleRetrievedToggle}
                                            searchQuery={searchQuery}
                                            selectedPrefix={selectedPrefix} //  pass selectedPrefix so child knows
                                        />

                                        {sortedRecords1.length > recordsPerPage1 && (
                                            <PaginationComponentForm2
                                                currentPage={currentPage1}
                                                totalPages={totalPages1}
                                                paginate={paginate1}
                                                recordsPerPage={recordsPerPage1}
                                                tableNames={sortedRecords1}
                                            />
                                        )}
                                    </div>
                                </div>
                            </div>
                            {/* right Column with Table */}
                            <div className="col-lg-8 col-md-12">
                                <div className={`card h-100 ${styles.cardBorder} ${styles.card}`}>
                                    <div className="card-body">
                                        {/* Header Section - Always visible */}
                                        <div className="d-flex justify-content-between align-items-center pb-2 mb-3 border-bottom border-dark">
                                            {/* Left: Heading */}
                                            <div className="flex-grow-1">
                                                <h6 className="mb-0">
                                                    Approve/Reject:{" "}
                                                    {selectedName
                                                        .replace(/_/g, ' ')
                                                        .split(' ')
                                                        .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
                                                        .join(' ')}
                                                </h6>
                                            </div>

                                            {/* Right: Search Box */}
                                            {showSearchInput && (
                                                <div className="d-flex align-items-center ms-3">
                                                    {/* Records Per Page Selector */}
                                                    <div className="me-3">
                                                        <select
                                                            className="form-select form-select-sm"
                                                            value={recordsPerPage}
                                                            onChange={handleRecordsPerPageChange}
                                                            style={{ width: '70px' }}
                                                        >
                                                            <option value="5">5</option>
                                                            <option value="25">25</option>
                                                            <option value="50">50</option>
                                                            <option value="100">100</option>
                                                        </select>
                                                    </div>

                                                    {/* Search Box */}
                                                    <div>
                                                        <SearchBox searchTerm={searchTerm} handleSearch={handleSearch} />
                                                    </div>
                                                    <div
                                                        className="custom-dropdown position-relative"
                                                        onMouseEnter={() => selectedName && setShowDropdown(true)}
                                                        onMouseLeave={() => selectedName && setShowDropdown(false)}
                                                    >
                                                        <button
                                                            className="btn btn-primary btn-sm btn-download"
                                                            data-toggle="tooltip"
                                                            data-placement="top"
                                                            title="Click to download the data"
                                                            onClick={handleDownloadClick}
                                                            disabled={!selectedName}
                                                        >
                                                            {selectedDownloadFormat ? `Download (.${selectedDownloadFormat})` : "Download"}
                                                        </button>


                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                        {formError && (
                                            <div className="text-center mt-4 text-muted">
                                                <strong>{formError}</strong>
                                            </div>
                                        )}

                                        {/* Selection count - show above the table */}
                                        {/* Records count section - always show when data exists */}
                                        {!isLoading && tableData.length > 0 && (
                                            <div className="text-start mb-2" style={{ fontSize: '12px' }}>
                                                {filteredSelectableRecords > 0 && (
                                                    <>
                                                        {selectedRowIds.length > 0 ? (
                                                            <span>
                                                                {selectedRowIds.length} out of {filteredSelectableRecords} records selected
                                                                {searchTerm && (
                                                                    <span className="text-muted ms-2">(filtered from {totalSelectableRecords} total records)</span>
                                                                )}
                                                            </span>
                                                        ) : (
                                                            <span>
                                                                Total {filteredSelectableRecords} records
                                                                {searchTerm && (
                                                                    <span className="text-muted ms-2">(from {totalSelectableRecords} total records)</span>
                                                                )}
                                                            </span>
                                                        )}
                                                    </>
                                                )}
                                            </div>
                                        )}

                                        {/* Loading State - After header but before table */}
                                        {isLoading && (
                                            <div className="d-flex justify-content-center align-items-center" style={{ height: '200px' }}>
                                                <UploadLoadingIcon />
                                            </div>
                                        )}

                                        {/* Content Section - Only visible when not loading */}
                                        {!isLoading && (
                                            <>
                                                <div className="col-md-12 w-100">
                                                    <DEMcheckertableStructure
                                                        isLoading={isLoading}
                                                        error={error}
                                                        currentRecords={currentRecords}
                                                        tableData={tableData}
                                                        tableColumns={tableColumns}
                                                        totalPages={totalPages}
                                                        currentPage={currentPage}
                                                        paginate={paginate}
                                                        handleApprove={handleApprove}
                                                        handleReject={handleReject}
                                                        selectedColumn={selectedColumn}
                                                        handleDropdownChange={handleDropdownChange}
                                                        selectedRowIds={selectedRowIds}
                                                        checkboxRowId={checkboxRowId}
                                                        setSelectedRowIds={setSelectedRowIds}
                                                        handleCheckboxChange={handleCheckboxChange}
                                                        handleSelectAll={handleSelectAll}
                                                        onSelectedRowIdsChange={handleSelectedRowIdsChange}
                                                        allSelectableRowIds={allSelectableRowIds} // Add this line
                                                        searchTerm={searchTerm} // Add this
                                                        filteredTableData={filteredTableData} // Add this
                                                        isRetrievedTable={isRetrievedTable}
                                                    />
                                                </div>

                                                {currentRecords.length > 0 && (
                                                    <div className="d-flex justify-content-center position-relative">
                                                        {/* Centered pagination */}
                                                        <div>
                                                            <PaginationComponentForm2
                                                                currentPage={currentPage}
                                                                totalPages={totalPages}
                                                                paginate={paginate}
                                                                recordsPerPage={recordsPerPage}
                                                            />
                                                        </div>

                                                        {/* Right-aligned buttons */}
                                                        <div className="position-absolute end-0">
                                                            <BulkApproveButton
                                                                currentPage={currentPage}
                                                                totalPages={totalPages}
                                                                searchTerm={searchTerm}
                                                                handleApproveBulk={handleApproveBulk}
                                                                handleBulkReject={handleBulkReject}
                                                                selectedRowIds={selectedRowIds}
                                                                checkboxRowId={checkboxRowId}
                                                            />
                                                        </div>
                                                    </div>
                                                )}
                                            </>

                                        )}
                                        <Modal show={showRejectModal} onHide={() => setShowRejectModal(false)} backdrop="static" keyboard={false} style={{ marginTop: '12vh' }}>
                                            <Modal.Header
                                                style={{
                                                    backgroundColor: '#366872',
                                                    color: 'white',
                                                    padding: '0.5rem 1rem'
                                                }}
                                                closeButton>
                                                <Modal.Title style={{ fontSize: '16px' }}>Reason for Rejection</Modal.Title>
                                            </Modal.Header>
                                            <Modal.Body style={{ padding: '0.75rem 1rem', fontSize: '14px' }}>
                                                <div className="form-group">
                                                    <label htmlFor="column-select" className="text-secondary">Select Reason</label>


                                                    <select
                                                        className="form-control"
                                                        id="column-select"
                                                        onChange={handleColumnSelect}
                                                        value={selectedColumn}


                                                    >
                                                        <option value="">Select Reason</option>

                                                        {(reasonColumnConfig[paramState] || tableColumns)
                                                            .filter(column => column !== "Maker_Remarks")
                                                            .map((column, index) => (
                                                                <option key={index} value={column}>
                                                                    {formatColumnLabel(column)} is not correct
                                                                </option>
                                                            ))}

                                                        <option value="DeleteRecord">Delete the record</option>
                                                        <option value="Others">Others</option>
                                                    </select>


                                                </div>
                                                <div className="form-group">
                                                    <label htmlFor="other-reason" className="text-secondary">Reason Details</label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        name="reason-input"
                                                        id="other-reason"
                                                        value={otherReason}
                                                        onChange={handleOtherReasonChange}
                                                        placeholder="Provide Reason here..."
                                                        required={isReasonRequired}
                                                    />
                                                </div>
                                            </Modal.Body>
                                            <Modal.Footer style={{ borderTop: 'none' }}>
                                                <Button variant="secondary" onClick={() => setShowRejectModal(false)}
                                                    style={
                                                        cancelButtonStyle
                                                    }

                                                >Cancel</Button>
                                                <Button
                                                    variant="primary"
                                                    onClick={() => handleRejectSubmit(selectedColumn, otherReason)}
                                                    disabled={isSubmitDisabled}

                                                    style={
                                                        ProceedButtonStyle

                                                    }
                                                >
                                                    Proceed
                                                </Button>
                                            </Modal.Footer>
                                        </Modal>

                                        <Modal show={showConfirmApprove} onHide={() => setShowConfirmApprove(false)} backdrop="static" keyboard={false} style={{ marginTop: '12vh' }}>
                                            <Modal.Header
                                                style={{
                                                    backgroundColor: '#366872',
                                                    color: 'white',
                                                    padding: '0.5rem 1rem'
                                                }}
                                                closeButton>
                                                <Modal.Title style={{ fontSize: '16px' }}>Confirm Approval</Modal.Title>
                                            </Modal.Header>
                                            <Modal.Body style={{ padding: '0.75rem 1rem', fontSize: '14px' }}>
                                                <p>Are you sure you want to Approve this record?</p>
                                            </Modal.Body >
                                            <Modal.Footer style={{ borderTop: 'none' }}>
                                                <Button variant="secondary"
                                                    style={
                                                        cancelButtonStyle
                                                    } onClick={() => setShowConfirmApprove(false)}>Cancel</Button>
                                                <Button variant="Primary"
                                                    style={
                                                        submitButtonStyle
                                                    } onClick={() => handleBulkApprove()}>Submit</Button>
                                            </Modal.Footer>
                                        </Modal>
                                        <Modal show={showNotifyModal} onHide={() => setShowNotifyModal(false)} backdrop="static" keyboard={false} style={{ marginTop: '12vh' }}>
                                            <Modal.Header
                                                style={{
                                                    backgroundColor: '#366872',
                                                    color: 'white',
                                                    padding: '0.5rem 1rem'
                                                }}
                                                closeButton>
                                                <Modal.Title style={{ fontSize: '16px' }}>Select Notification Preference</Modal.Title>
                                            </Modal.Header>
                                            <Modal.Body style={{ padding: '0.75rem 1rem', fontSize: '14px' }}>
                                                <Form>
                                                    <Form.Check
                                                        type="radio"
                                                        label={<span style={{ color: 'black' }}>Immediate Notify</span>}
                                                        name="notificationType"
                                                        value="IN"
                                                        checked={notificationType === 'IN'}
                                                        onChange={() => handleNotificationTypeChange('IN')}
                                                    />
                                                    <Form.Check
                                                        type="radio"
                                                        label={<span style={{ color: 'black' }}>End of Day Notify</span>}
                                                        name="notificationType"
                                                        value="EOD"
                                                        checked={notificationType === 'EOD'}
                                                        onChange={() => handleNotificationTypeChange('EOD')}
                                                    />
                                                </Form>
                                            </Modal.Body>
                                            <Modal.Footer style={{ borderTop: 'none' }}>
                                                <Button variant="secondary"
                                                    style={closeButtonStyle}
                                                    onClick={() => setShowNotifyModal(false)}>
                                                    Close
                                                </Button>
                                                <Button variant="primary"
                                                    style={submitButtonStyle}
                                                    onClick={handleBulkSubmit}>
                                                    Submit
                                                </Button>
                                            </Modal.Footer>
                                        </Modal>


                                        <Modal show={modalMessage} onHide={() => setModalMessage('')} backdrop="static" keyboard={false} style={{ marginTop: '12vh' }}>
                                            <div
                                                className={`alert alert-${messageType === 'success' ? 'success' :
                                                    messageType === 'warning' ? 'warning' :
                                                        'danger'
                                                    } alert-dismissible fade show`}
                                                role="alert"
                                                style={{ marginBottom: '0' }}
                                            >
                                                <div className="d-flex align-items-center">
                                                    {messageType === 'success' ? (
                                                        <span className="me-2" style={{ color: 'green' }}>✅</span>
                                                    ) : messageType === 'warning' ? (
                                                        <span className="me-2" style={{ color: '#FFC107' }}>⚠️</span>
                                                    ) : (
                                                        <span className="me-2" style={{ color: 'red' }}>❌</span>
                                                    )}

                                                    <p
                                                        style={{
                                                            display: 'inline',
                                                            marginBottom: '0px',
                                                            fontSize: '14px',
                                                            color:
                                                                messageType === 'success' ? 'green' :
                                                                    messageType === 'warning' ? '#856404' : 'red'
                                                        }}

                                                        dangerouslySetInnerHTML={{ __html: modalMessage }} >
                                                    </p>
                                                </div>
                                                <button
                                                    type="button"
                                                    className="btn-close"
                                                    onClick={goBack}
                                                    style={{
                                                        width: '15px',
                                                        height: '15px',
                                                        fontSize: '8px',
                                                        position: 'absolute',
                                                        bottom: '10px',
                                                        right: '10px',
                                                    }}
                                                ></button>
                                            </div>
                                        </Modal>


                                        <Modal show={showRejectReasonModal} onHide={() => setShowRejectReasonModal(false)} backdrop="static" keyboard={false} style={{ marginTop: '12vh' }}>
                                            <Modal.Header
                                                style={{
                                                    backgroundColor: '#366872',
                                                    color: 'white',
                                                    padding: '0.5rem 1rem'
                                                }}
                                                closeButton>
                                                <Modal.Title style={{ fontSize: '16px' }}>Reason for Rejection</Modal.Title>
                                            </Modal.Header>
                                            <Modal.Body style={{ padding: '0.75rem 1rem', fontSize: '14px' }}>
                                                <div className="form-group">
                                                    <label htmlFor="column-select" className="text-secondary">Select Reason</label>

                                                    <select
                                                        className="form-control"
                                                        id="column-select"
                                                        onChange={handleColumnSelect}
                                                        value={selectedColumn}
                                                    >
                                                        <option value="">Select Reason</option>

                                                        {(reasonColumnConfig[paramState] || tableColumns)
                                                            .filter(column => column !== "Maker_Remarks")
                                                            .map((column, index) => (
                                                                <option key={index} value={column}>
                                                                    {formatColumnLabel(column)} is not correct
                                                                </option>
                                                            ))}

                                                        <option value="DeleteRecord">Delete the record</option>
                                                        <option value="Others">Others</option>
                                                    </select>

                                                </div>
                                                <div className="form-group">
                                                    <label htmlFor="other-reason" className="text-secondary">Reason Details</label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        name="reason-input"
                                                        id="other-reason"
                                                        value={otherReason}
                                                        onChange={handleOtherReasonChange}
                                                        placeholder="Provide Reason here..."
                                                        required={isReasonRequired}
                                                    />
                                                </div>
                                            </Modal.Body>
                                            <Modal.Footer style={{ borderTop: 'none' }}>
                                                <Button variant="secondary" onClick={() => setShowRejectReasonModal(false)}
                                                    style={
                                                        cancelButtonStyle
                                                    }

                                                >Cancel</Button>
                                                <Button
                                                    variant="primary"
                                                    onClick={() => handleReasonSubmit(selectedColumn, otherReason)}
                                                    disabled={isSubmitDisabled}

                                                    style={
                                                        ProceedButtonStyle
                                                    }
                                                >
                                                    Proceed
                                                </Button>
                                            </Modal.Footer>
                                        </Modal>
                                        <Modal show={showConfirmApproveModal} onHide={() => setShowConfirmApproveModal(false)} backdrop="static" keyboard={false} style={{ marginTop: '12vh' }}>
                                            <Modal.Header
                                                style={{
                                                    backgroundColor: '#366872',
                                                    color: 'white',
                                                    padding: '0.5rem 1rem'
                                                }}
                                                closeButton>
                                                <Modal.Title style={{ fontSize: '16px' }}>Confirm Approval</Modal.Title>
                                            </Modal.Header>
                                            <Modal.Body style={{ padding: '0.75rem 1rem', fontSize: '14px' }}>
                                                <p>Are you sure you want to approve this record?</p>
                                            </Modal.Body>
                                            <Modal.Footer style={{ borderTop: 'none' }}>
                                                <Button variant="secondary" style={
                                                    cancelButtonStyle
                                                } onClick={() => setShowConfirmApproveModal(false)}>Cancel</Button>
                                                <Button variant="secondary" style={
                                                    submitButtonStyle
                                                } onClick={() => handleConfirmApprove()}>Submit</Button>
                                            </Modal.Footer>
                                        </Modal>


                                        {/* Notify Priority Modal */}
                                        <Modal show={showNoRecordsModal} onHide={() => setShowNoRecordsModal(false)} backdrop="static" keyboard={false} style={{ marginTop: '12vh' }}>
                                            <Modal.Header
                                                style={{
                                                    backgroundColor: '#366872',
                                                    color: 'white',
                                                    padding: '0.5rem 1rem'
                                                }}
                                                closeButton>
                                                <Modal.Title style={{ fontSize: '16px' }}>No Records Found</Modal.Title>
                                            </Modal.Header>
                                            <Modal.Body style={{ padding: '0.75rem 1rem', fontSize: '14px' }}>No records match your search criteria.</Modal.Body>
                                            <Modal.Footer style={{ borderTop: 'none' }}>
                                                <Button variant="secondary"
                                                    style={closeButtonStyle}
                                                    onClick={() => setShowNoRecordsModal(false)}>
                                                    Close
                                                </Button>
                                            </Modal.Footer>
                                        </Modal>



                                        {/* Reason Modal */}
                                        <Modal show={showReasonModal} onHide={handleReasonClose} backdrop="static" keyboard={false} style={{ marginTop: '12vh' }}>
                                            <Modal.Header
                                                style={{
                                                    backgroundColor: '#366872',
                                                    color: 'white',
                                                    padding: '0.5rem 1rem'
                                                }}
                                                closeButton>
                                                <Modal.Title style={{ fontSize: '16px' }}>Other Reason</Modal.Title>
                                            </Modal.Header>
                                            <Modal.Body style={{ padding: '0.75rem 1rem', fontSize: '14px' }}>
                                                <p>Please provide your reason:</p>
                                                <textarea
                                                    className="form-control"
                                                    rows="3"
                                                    value={otherReason}
                                                    onChange={(e) => setOtherReason(e.target.value)}
                                                />
                                            </Modal.Body>
                                            <Modal.Footer style={{ borderTop: 'none' }}>
                                                <Button variant="secondary" onClick={handleReasonClose}
                                                    style=
                                                    {
                                                        cancelButtonStyle
                                                    }

                                                >Cancel</Button>
                                                <Button variant="primary" onClick={handleReasonSubmit}
                                                    style={
                                                        ProceedButtonStyle
                                                    }
                                                >Proceed</Button>
                                            </Modal.Footer>
                                        </Modal>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </main >
            <Footer />

            <Modal show={!!modalMessageOne} onHide={handlemodalclose} backdrop="static" keyboard={false} style={{ marginTop: '12vh' }}>
                <div className={`alert alert-warning alert-dismissible fade show`} role="alert" style={{ marginBottom: '0' }}>
                    <div className="d-flex align-items-center">
                        <span className="me-2" style={{ color: 'orange', marginBottom: "14px" }}>⚠️</span>
                        <p style={{ display: 'inline', color: modalMessageOne === 'Table is under modifications' ? 'warning' : (messageType === 'warning' ? 'red' : 'warning') }}
                            dangerouslySetInnerHTML={{ __html: modalMessageOne }} >
                        </p>
                    </div>
                    <button
                        type="button"
                        className="btn-close"
                        onClick={handlemodalclose}
                        style={{
                            width: '15px',
                            height: '15px',
                            fontSize: '8px',
                            position: 'absolute',
                            bottom: '10px',
                            right: '10px',
                        }}
                    ></button>
                </div>
            </Modal>
        </div >
    );
};

export default GapsyRData;